<div *ngIf="isLoading" class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>
<div class="container" *ngIf="orderItems.length > 0; else noItems">
    <div class="heading-container">
        <div class="heading-left-section">
            <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
            <p class="heading">{{ heading }}</p>
        </div>
        <div class="heading-right-section">
            <mat-checkbox
                class="hidden-checkbox"
                [indeterminate]="isSomeSelected()"
                [checked]="isAllSelected()"
                (change)="toggleSelectAll($event)"
            >
            </mat-checkbox>
            <div class="select-btn-content">
                <app-button
                    variant="white"
                    buttonClass="shadow-btn"
                    *ngIf="orderItems.length > 1"
                    (click)="onSelectAllButtonClick()"
                >
                    {{
                        isAllSelected()
                            ? ("orderItemList.button.unselectAll" | translate)
                            : ("orderItemList.button.selectAll" | translate)
                    }}
                </app-button>
            </div>
        </div>
    </div>
    <div class="middle-section">
        <app-button variant="hero" [disabled]="!selectedItems.size" (click)="navigateReturnReplacePage()">
            {{ buttonLabel }}
        </app-button>
    </div>
    <div class="product-section">
        @for (orderItem of orderItems; track $index) {
        <div class="product">
            <mat-checkbox
                (change)="toggleSelectItem(orderItem?.id!)"
                [checked]="selectedItems.has(orderItem?.id!)"
            ></mat-checkbox>
            <div class="top-section">
                <img class="product-image" [src]="orderItem.product?.images?.imagesUrl?.[0]" />
                <p
                    class="product-name"
                    [matTooltipShowDelay]="800"
                    [matTooltipHideDelay]="500"
                    [matTooltip]="orderItem.product?.name"
                >
                    <span>{{ orderItem.product?.name }}</span>
                </p>
            </div>
        </div>
        }
    </div>
</div>

<ng-template #noItems>
    <div class="empty-state" *ngIf="!isLoading">
        <div class="empty-message-content">
            <mat-icon class="info-icon">info</mat-icon>
            <p class="empty-message">
                {{ "orderItemList.moItem" | translate }}
                {{
                    type === "return"
                        ? ("orderItemList.return" | translate)
                        : type === "exchange"
                        ? ("orderItemList.exchange" | translate)
                        : ("orderItemList.cancel" | translate)
                }}.
            </p>
        </div>
        <app-button variant="hero" routerLink="/account/trackOrder">
            {{ "orderItemList.button.back" | translate }}
        </app-button>
    </div>
</ng-template>
